/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Ответственное лицо
 */
export interface ResponsiblePersonResponse {
  /**
   * Идентификатор ответственного лица
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор клиента
   * @format uuid
   */
  clientId?: string;

  /** ФИО ответственного лица */
  fullName?: string;

  /** Телефон ответственного лица */
  phone?: string;

  /** Признак неактивной записи */
  isNotActive?: boolean;
}

/**
 * Валюта
 */
export interface CurrencyResponse {
  /**
   * Идентификатор валюты
   * @format uuid
   */
  id: string;

  /** Наименование валюты ISO */
  name: string;

  /** Буквенный код валюты ISO */
  alphabeticCode: string;

  /** Цифровой код валюты ISO */
  numericCode: string;

  /** Наименование валюты ОКВ */
  okvName: string;

  /** Символ валюты */
  symbol: string;

  /** Идентификатор кода срока привлечения */
  isActive: boolean;
}

/**
 * Страна
 */
export interface CountryResponse {
  /**
   * Идентификатор страны
   * @format uuid
   */
  id?: string;

  /** Код страны */
  codeIso?: string;

  /** Наименование страны */
  fullName?: string;

  /** Краткое наименование страны */
  shortName?: string;

  /** Латинское наименование страны */
  englishName?: string;

  /** 3-х буквенный код страны */
  charCode3?: string;

  /** 2-х буквенный код страны */
  charCode2?: string;
}

/**
 * Детальная информация о Клиенте
 */
export interface ClientDetailResponse {
  /** @format uuid */
  id?: string;
  shortName?: string;
  shortNameLatin?: string;
  fullName?: string;
  fullNameLatin?: string;
  address?: string;
  addressLatin?: string;
  chief?: string;
  accChief?: string;
  inn?: string;
  kpp?: string;
  kio?: string;
  ogrn?: string;
  okato?: string;
  okpo?: string;
  email?: string;
  phone?: string;
  fax?: string;
  country?: string;
  opfShort?: string;
  clientType?: string;
  regBy?: string;
  vip?: boolean;

  /** @format int32 */
  signCount?: number;

  /** @format date */
  regDate?: string;
  branchCode?: string;
  branchBic?: string;
  branchName?: string;
  branchCorrAccountNumber?: string;

  /** @format uuid */
  branchId?: string;
  sspZone?: string;
  finalSegment?: string;
  deleted?: boolean;
  latinNameEditionProhibited?: boolean;
}

import { HttpClient } from "../../client";
import { RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-ved-common
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl http://localhost:8080
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Получение ответственных лиц Клиента
     * @name GetResponsiblePerson
     * @summary Получение списка ответственных лиц Клиента
     * @request GET:/api/ved-common/v1/external/responsible-person
     * @secure
     */
    getResponsiblePerson: (
      query?: { isNotActive?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<ResponsiblePersonResponse[], GenericError>({
        path: `/api/ved-common/v1/external/responsible-person`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файлы
     * @name Download
     * @summary Получение файла
     * @request GET:/api/ved-common/v1/external/files/{id}/download
     * @secure
     */
    download: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/ved-common/v1/external/files/${id}/download`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из справочников
     * @name GetCurrencies
     * @summary Получение справочника "Валюты"
     * @request GET:/api/ved-common/v1/external/dict/currency
     * @secure
     */
    getCurrencies: (params: RequestParams = {}) =>
      this.request<CurrencyResponse[], GenericError>({
        path: `/api/ved-common/v1/external/dict/currency`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из справочников
     * @name GetCountries
     * @summary Получение справочника "Страны"
     * @request GET:/api/ved-common/v1/external/dict/country
     * @secure
     */
    getCountries: (params: RequestParams = {}) =>
      this.request<CountryResponse[], GenericError>({
        path: `/api/ved-common/v1/external/dict/country`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из справочников
     * @name GetClient
     * @summary Получение детальной информации о клиенте
     * @request GET:/api/ved-common/v1/external/dict/client
     * @secure
     */
    getClient: (params: RequestParams = {}) =>
      this.request<ClientDetailResponse, GenericError>({
        path: `/api/ved-common/v1/external/dict/client`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
